import "@fancyapps/ui/dist/fancybox.css";
import {Fancybox} from "@fancyapps/ui";

Fancybox.defaults.Hash = false;

export class FancyboxClass {
    constructor() {
        this.initFancybox();
    }

    initFancybox() {
        Fancybox.bind("[data-fancybox]", {
            infinite: false,
            hash: false,
            type: 'inline',
            toolbar: false,
            touch: false,
            dragToClose: false,
            autoFocus: false,
            trapFocus: false,
        });

        Fancybox.bind("[data-fancybox-iframe]", {
            infinite: false,
            hash: false,
            type: 'iframe',
            toolbar: false,
            touch: false,
            dragToClose: false,
            autoFocus: false,
            trapFocus: false,
        });

        Fancybox.bind("[data-support-ticket-fancybox]", {
            infinite: false,
            hash: false,
            type: 'inline',
            toolbar: false,
            touch: false,
            dragToClose: false,
            autoFocus: false,
            trapFocus: false,
            on: {
                ready: function () {
                    window.fieldsChanged = 0;
                }, shouldClose: function () {
                    if (window.fieldsChanged > 0 && window.formSaved !== true) {
                        return confirm('Du har foretaget en ændring uden at gemme. Vælg OK, hvis du vil lukke popupen');
                    }
                }
            }
        });

        Fancybox.bind("[data-booking-fancybox]", {
            infinite: false,
            hash: false,
            type: 'inline',
            toolbar: false,
            touch: false,
            dragToClose: false,
            autoFocus: false,
            trapFocus: false
        });

        Fancybox.bind("[data-cloud-data-fancybox]", {
            infinite: false,
            hash: false,
            type: 'inline',
            toolbar: false,
            touch: false,
            dragToClose: false,
            autoFocus: false,
            trapFocus: false
        });
    }

    closeFancybox() {
        Fancybox.close();
    }

    openImage(src) {
        Fancybox.show([{src: src, type: "image"}]);
    }

    closeSelectedFancybox(fancybox) {
        fancybox.close();
    }

    getCurrentOpenFancybox() {
        return Fancybox.getInstance();
    }

    isFancyboxOpen() {
        let instance = Fancybox.getInstance();
        return instance ? instance.state !== 'closed' : false;
    }

    openFancybox(src) {
        Fancybox.show([{src: src, type: "html"}]);
    }
}

export const fancybox = new FancyboxClass();